export default __webpack_public_path__ + "static/media/non-interface-apis.36ed0e2d.svg";